module.exports = __webpack_public_path__ + "img/prepare-files.7831ecf4.svg";